<template>
  <div class="titleHeader" :style="{ color: color, backgroundColor: bgcolor }">
    <div class="view view--l">
      <img
        v-if="hasNavBack"
        class="nav_back"
        src="/static/icon/nav_back.png"
        alt=""
        @click="onNavBack"
      />
      <slot name="left" />
    </div>
    <div class="view">
      <p class="title" v-if="title">{{ title }}</p>
      <slot name="title" />
    </div>
    <div class="view view--r">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
import commonApi from "@/utils/common";

export default {
  name: "titleHeader",
  props: {
    title: String,
    color: String,
    bgcolor: {
      type: String,
      default: "white",
    },
    back: {
      // 是否显示原生后退按钮（switchBackBtn）
      type: Boolean,
      default: false,
    },
    hasNavBack: {
      // H5 自绘返回箭头（switchNavbar false 后需用此）
      type: Boolean,
      default: false,
    },
  },
  watch: {
    back: {
      immediate: true,
      handler(val) {
        this.JSBridge.callHandler("switchBackBtn", val);
      },
    },
  },
  methods: {
    onNavBack() {
      commonApi.pageBack();
    },
  },
};
</script>

<style lang="scss" scoped>

.titleHeader {
  position: relative;
  @extend %l-header-mobile;
  padding: 0 12vw;
  .search {
    width: 100%;
    height: var(--nav-content-height, 36px);
  }

  .nav_back {
    width: 23px;
    height: 23px;
    display: block;
    object-fit: contain;
  }

  .view {
    @extend %l-flex-mobile;
    justify-content: center;
    -webkit-justify-content: center;
    align-items: center;
    -webkit-align-items: center;
    height: 100%;

    .title {
      @include singleLine;
      font-weight: bold;
      font-size: 16px;
      padding: 0;
    }
    &--l {
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
      margin-left: 12px;
      width: auto;
      font-size: 13px;
      font-weight: normal;
      color: $c-info;
    }
    &--r {
      position: absolute;
      height: 100%;
      top: 0;
      right: 0;
      margin-right: 12px;
      width: auto;
      font-size: 13px;
      font-weight: normal;
      color: $c-info;
    }
  }

  &.no-mr {
    .view--r {
      margin-right: 0;
    }
  }
}
</style>
